var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container mescroll-touch"},[_c('Questionnaire',{attrs:{"questionId":_vm.questionId,"sourceType":_vm.sourceType,"sourceId":_vm.sourceId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }